import { Mfe, Url, GlobalInfo, Device, Env } from '@loca/mfe-vue3'
import envConfig from '@/utils/envConfig'
import Analytics from '@/core/Analytics'
import Navigator from '@/core/Navigator'
import { HeaderUtils } from '@/components/HeaderNav/HeaderUtils'
import { LayoutUtils } from '@/components/Layout/LayoutUtils'
import { handleTransferMessage, isFeishuWebview, initFeishuBridgeManager, FeishuBridgeUtils } from '@/utils/feishuBridge'
import microAppLifeCycle from './microAppLifeCycle'
import originApps from './config'


function initGlobalInfo() {
  // 当前环境
  GlobalInfo.set('env', Env.getEnv())

  // 当前版本（国内/海外）
  GlobalInfo.set('appType', Env.getAppType())

  // 手动创建/加载子应用
  if (!GlobalInfo.get('createMicroApp')) {
    GlobalInfo.set('createMicroApp', Mfe.createMicroApp)
  }

  // appSystemInfo 如 client container 等
  const { lang, region } = Env.getLangRegion()
  const client = Device.isMobile() ? 'mobile' : 'pc'
  const container = 'browser'
  const appSystemInfo = Url.getAppSystemInfoFromUrl()
  GlobalInfo.set('appSystemInfo', {
    lang,
    region,
    client,
    container,
    ...appSystemInfo,
  })
}


export const initMfeConfig = () => {
  try {
    const { APP_ID, BASE_MICRO_APPS } = envConfig
    const { version } = require('../../package.json')

    GlobalInfo.set('appId', APP_ID)
    GlobalInfo.set('appVer', version)

    // 对一些主应用配置进行初始化
    Mfe.config.commonParams = { appId: APP_ID, appVer: version }
    Mfe.config.microAppHost = BASE_MICRO_APPS
    Mfe.config.containerSelector = '#microAppContainer'
    Mfe.config.microAppLifeCycle = microAppLifeCycle
    Mfe.config.originMicroApps = originApps
    Mfe.config.safeAreaTopOffset = 44
    Mfe.config.qiankunRootPropsSdk = {
      Analytics,
      Navigator,
      HeaderUtils,
      LayoutUtils,
      handleTransferMessage,
      isFeishuWebview,
      FeishuBridgeUtils,
    }
  } catch (error) {
    console.error('[MFE] 主应用初始化配置异常')
  }
}

initGlobalInfo()
Url.initStatusBarHeightStyle()
initMfeConfig()
initFeishuBridgeManager()

export default Mfe.startMfe
